import { useEffect, useContext, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { Box, Button, Paper } from '@mui/material';
import { getReport } from '../../api/reporting';
import { ReportingContext } from './ReportingContainer';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { DataGrid, gridFilteredSortedRowIdsSelector } from '@mui/x-data-grid';
import CustomToolbar from './CustomToolbar';
import dayjs from 'dayjs';

export const DisplayReport = () => {
  const { reportName, endpoint, endpointParams, navToReportingPage } = useContext(ReportingContext);
  const [report, setReport] = useState([]);
  const [reportColumns, setReportColumns] = useState([]);

  const userName = sessionStorage.getItem('name');
  const startDate = endpointParams?.startDate?.split(' ')[0];
  const endDate = endpointParams?.endDate?.split(' ')[0];

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0'); // 26
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 02 (Months are 0-based)
    const year = String(date.getFullYear()).slice(-2); // 25
    const hours = String(date.getHours()).padStart(2, '0'); // 09
    const minutes = String(date.getMinutes()).padStart(2, '0'); // 51
    const seconds = String(date.getSeconds()).padStart(2, '0'); // 25

    return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    const fetch = async () => {
      const rawData = await getReport(endpoint, endpointParams);

      const reportData = rawData.map((row, i) => {
        const newRow = { ...row, id: i };

        if (row['Last Modified']) {
          newRow['Last Modified'] = formatDate(row['Last Modified']);
        }

        return newRow;
      });

      setReport(reportData);
      setReportColumns(
        Object.keys(reportData?.[0] || {})
          .filter((k) => k !== 'id')
          .map((k) => {
            return {
              field: k,
              headerName: k === 'Last Modified' ? 'Last Modified' : k,
              headerClassName: 'table-header',
              flex: 1,
            };
          })
      );
    };
    fetch();
  }, []);

  const getRowsFromCurrentPage = ({ apiRef }) => gridFilteredSortedRowIdsSelector(apiRef);

  return (
    <Grid className="two-column-divs right-container" sx={{ padding: 3 }}>
      <Box
        sx={{
          mb: 2,
          fontSize: '24px',
          fontWeight: '100',
          fontFamily: 'Roboto, sans-serif',
        }}
      >
        <span>{reportName}</span>
        {startDate && endDate && (
          <p style={{ fontSize: '16px' }}>
            Date Range: {dayjs(startDate).format('DD/MM/YYYY')} to {dayjs(endDate).format('DD/MM/YYYY')}
          </p>
        )}
      </Box>

      <Paper sx={{ width: '100%' }}>
        <DataGrid
          id={reportName}
          rows={report}
          columns={reportColumns}
          pageSizeOptions={[5, 10]}
          key={0}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          slots={{
            toolbar: () => {
              return (
                <CustomToolbar reportName={reportName} userName={userName} startDate={startDate} endDate={endDate} />
              );
            },
          }}
          slotProps={{
            toolbar: {
              printOptions: { disableToolbarButton: true },
              csvOptions: {
                fileName: reportName,
                getRowsToExport: getRowsFromCurrentPage,
              },
            },
          }}
          sx={{ border: 0 }}
        />
      </Paper>
      <Button
        sx={{ width: '80px', mt: 2 }}
        variant="text"
        startIcon={<ArrowBackIosIcon />}
        onClick={() => navToReportingPage(null)}
      >
        Back
      </Button>
    </Grid>
  );
};
